// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__Y8v7j","option":"SuperSelect_option__-mvjf"};